<script setup lang="ts">
import type { ObserveScrollConfig, ActionPosition } from '@mop/types/index';

const HIDE_STICKY_BOTTOM_GAP = 500;

defineOptions({
  name: 'MopFooterJobsStickyButton',
});

const { $gtm } = useNuxtApp();
const route = useRoute();
const isStickyRef = ref(true);
const isVisibleRef = computed(() => {
  return route.meta.hideJobsStickyButton !== true;
});

const stickyConfig: ObserveScrollConfig = {
  calculateActionPositions: () => {
    const stickyEndPosition = document.body.scrollHeight - (window.innerHeight ?? 0) - HIDE_STICKY_BOTTOM_GAP;
    if (stickyEndPosition < 0) {
      return [];
    }
    const actionPositionSticky: ActionPosition = {
      onEnter: () => {
        isStickyRef.value = true;
      },
      onLeave: () => {
        isStickyRef.value = false;
      },
      positionStart: 0,
      positionEnd: stickyEndPosition,
    };
    return [actionPositionSticky];
  },
  allowedViewports: `${BREAKPOINT.TINY} ${BREAKPOINT.SMALL}`,
};

function trackJobButtonClick() {
  $gtm.trackEvent({
    eventName: 'our_jobs_button',
    parameters: ['click', document.location.pathname],
  });
}
</script>
<template>
  <NuxtLink
    v-if="isVisibleRef"
    v-observe-scroll="stickyConfig"
    :to="$mopI18n.localePath(`${$urls.CAREER_PAGE}`)"
    :class="[
      'footer-jobs-sticky-button',
      {
        'footer-jobs-sticky-button--show': isStickyRef,
      },
    ]"
    @click="trackJobButtonClick"
  >
    {{ $mopI18n.t('locale.jobs.search_button') }}
  </NuxtLink>
</template>

<style lang="scss" scoped>
.footer-jobs-sticky-button {
  @include text-style(strong);
  @include z(global, abovecontent);
  position: fixed;
  background: $black;
  color: $white;
  text-transform: uppercase;
  padding: $space15;
  display: block;
  text-align: center;
  bottom: 0;
  width: 100%;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  @include apply-from(medium) {
    display: none;
  }
}
.footer-jobs-sticky-button--show {
  transform: translateY(0);
}
</style>
